// @flow
import * as React from "react"
import RefreshIndicator from "material-ui/RefreshIndicator"
import branch from "recompose/branch"
import renderComponent from "recompose/renderComponent"

export const LoadingSpinner = ({
  left = 0,
  top = 0,
  size = undefined,
  ...props
}: Object) => (
  <div {...props} style={{position: "relative"}}>
    <RefreshIndicator
      status="loading"
      style={{display: "inline-block", position: "relative"}}
      {...{left, top, size}}
    />
  </div>
)

export const loadingIf = (pred: ({}) => boolean) =>
  branch(pred, renderComponent(LoadingSpinner))
export const readyIf = (pred: ({}) => boolean) =>
  loadingIf(props => !pred(props))
function areNamesDefined(names, props) {
  for (let name of names) {
    if (props[name] === undefined) {
      return false
    }
  }
  return true
}
export const propsLoading = (names: Array<string>) =>
  readyIf(props => areNamesDefined(names, props))
export const propsLoadings = (...names: Array<string>) => propsLoading(names)



// WEBPACK FOOTER //
// ./src/common/LoadingSpinner.js